"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _helpers = _interopRequireDefault(require("./helpers"));
var _helpers2 = require("../helpers");
var _misc = require("../../misc");
var _Icon = _interopRequireDefault(require("../../icon/Icon"));
var _Minimum = _interopRequireDefault(require("./Minimum"));
var _Maximum = _interopRequireDefault(require("./Maximum"));
var _Placeholder = _interopRequireDefault(require("./Placeholder"));
var _FormulaRange = _interopRequireDefault(require("./FormulaRange.style"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialFormula = function initialFormula(_ref) {
  var formula = _ref.formula,
    rule = _ref.rule,
    ruleChange = _ref.ruleChange;
  ruleChange('complex', _objectSpread(_objectSpread({}, rule.complex), {}, _defineProperty({}, rule.complex.activeType, _objectSpread(_objectSpread({}, R.path(['complex', rule.complex.activeType], rule)), {}, {
    minimum: formula,
    maximum: formula
  }))));
};
var FormulaRange = function FormulaRange(props) {
  var disabled = props.disabled,
    rule = props.rule,
    labels = props.labels,
    ruleIndex = props.ruleIndex,
    ruleChange = props.ruleChange,
    actions = props.actions,
    setHasChanges = props.setHasChanges,
    placeholderLabel = props.placeholderLabel;
  var activeType = R.path(['complex', 'activeType'], rule);
  return /*#__PURE__*/_react["default"].createElement(_FormulaRange["default"], {
    "data-testid": "formula-range-wrapper"
  }, R.length(R.path(['complex', activeType, 'minimum'], rule)) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "formula-range-body"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    position: "top-right",
    disabled: disabled,
    menuItems: (0, _helpers["default"])({
      labels: labels,
      actions: actions,
      ruleIndex: ruleIndex,
      setHasChanges: setHasChanges
    }),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-more-vertical"
  })), /*#__PURE__*/_react["default"].createElement(_Minimum["default"], props), /*#__PURE__*/_react["default"].createElement(_Maximum["default"], props)) : /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
    label: placeholderLabel,
    disabled: disabled,
    createInitialFormula: R.compose(function (formula) {
      return initialFormula({
        formula: formula,
        rule: rule,
        ruleChange: ruleChange
      });
    }, _helpers2.createInitialFormula)
  }));
};
FormulaRange.defaultProps = {
  disabled: false
};
FormulaRange.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  rule: _propTypes["default"].shape({}).isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  actions: _propTypes["default"].shape({
    deleteRuleRange: _propTypes["default"].func.isRequired
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired,
  placeholderLabel: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = FormulaRange;